import React from 'react';
import '../styles/Methodology.css';
import methodologyImage from '../assets/methodology.png';

const Methodology = () => {
  return (
    <div className="methodology-section">
      <img
        src={methodologyImage}
        alt="Methodology"
        className="methodology-image"
      />
    </div>
  );
};

export default Methodology;
